import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import t from 'format-message';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { IconButton } from '@instructure/ui-buttons';
import { IconEndSolid, IconSearchLine } from '@instructure/ui-icons';
import { TextInput } from '@instructure/ui-text-input';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
var SearchInput = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchInput, _React$Component);
  var _super = _createSuper(SearchInput);
  function SearchInput() {
    _classCallCheck(this, SearchInput);
    return _super.apply(this, arguments);
  }
  _createClass(SearchInput, [{
    key: "renderClearSearchButton",
    value: function renderClearSearchButton() {
      var onClear = this.props.onClear;
      return jsx(IconButton, {
        size: "small",
        withBackground: false,
        withBorder: false,
        onClick: onClear,
        screenReaderLabel: t('Clear search field')
      }, jsx(IconEndSolid, {
        size: "x-small"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        searchText = _this$props.searchText;
      return jsx("span", {
        css: this.props.styles.search
      }, jsx(TextInput, {
        type: "search",
        renderLabel: jsx(ScreenReaderContent, null, t('Search outcomes')),
        placeholder: t('Search Outcomes'),
        value: searchText,
        onChange: onChange,
        size: "medium",
        renderAfterInput: searchText ? this.renderClearSearchButton() : jsx(IconSearchLine, {
          size: "x-small"
        })
      }));
    }
  }]);
  SearchInput.displayName = "SearchInput";
  return SearchInput;
}(React.Component), _class2.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  searchText: PropTypes.string.isRequired,
  styles: stylesShape
}, _class2)) || _class);
export { SearchInput as default };